import LiveBackground, { useLiveBackground } from "../../liveBackground/LiveBackground";
import {getDateTime} from "../../../utility/dateUtils";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {configLeap, drawingV2} from "../../../constant/initDrawing";
import Welcome from "../Welcome";
import Loading from "../../results/loading";
import Random from "../../results/random";
import _ from "lodash";
import ContentWrapper from "../mt/ContentWrapper";
import LayoutWrapper from "../mt/LayoutWrapper";

const post = ["B", "F", "C", "I", "D", "N"];

const config = configLeap;

const NumberNoSign = ({num}) => {
    if (num.includes("?") || num.includes("*")) return ""
    return num;
}


const RenderRow = ({row, i}) => {
    if (i > 0) {
        return <div className="row">
            {row.map((num, j) => {
                return <div style={{...config.style[`row_${i}_child`], fontSize: "45px"}} key={j}
                            className={`p-0 col-${config.iToCol[i]}`}>
                    <RenderItem num={num} i={i} j={j}/>
                </div>
            })}
        </div>
    }
    return <RenderItem num={row} i={i} j={-1}/>;
}

const RenderItem = ({num, i, j}) => {
    if (i === 0 || i === 2) {
        return <div className="d-flex justify-content-center align-items-center h-100 w-100">
            <div style={config.style[`row_${i}_child_num`]}>
                <span style={config.style.postLabel}>{j === -1 ? "A" : post[j]}</span>
                <span style={{
                    padding: "0 10px"
                }}> = <RenderNumber num={num}/></span>
            </div>
        </div>
    }
    return <RenderNumber num={num}/>;
}

const RenderNumber = ({num}) => {
    let val = Array.isArray(num) ? num[0] : num;
    if (val.includes("*")) {
        return <Loading style={config.style.loading} sizeDigit={val.length}/>
    } else if (val.includes("?")) {
        return <Random style={config.style.random} sizeDigit={val.length}/>
    } else return val
}

const RenderResultItem = ({item}) => {
    return <div style={config.style.resultItem} className="d-flex align-items-center">
        <div style={config.style.resultChild}>
            <NumberNoSign num={item.slice(-4)}/>
        </div>
        <div style={{...config.style.resultChild, ...config.style.result3d}}>
            <NumberNoSign num={item.slice(-3)}/>
        </div>
        <div style={config.style.resultChild}>
            <NumberNoSign num={item.slice(-2)}/>
        </div>
    </div>
}

const Live2Leap = ({socket}) => {
    const navigate = useNavigate();
    const backgroundType = useLiveBackground();
    const [result, setResult] = useState(drawingV2);

    useEffect(() => {
        socket.on(`leap5d_result`, (draw) => {
            setResult(draw);
        });
        socket.on(`leap6d_result`, (draw) => {
            setResult(draw);
        });

        return () => {
            socket.off(`leap5d_result`);
            socket.off(`leap6d_result`);
        }
    }, [socket]);

    const onStartDraw = (result) => {
        setResult(result)
    }

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw}/>

    return <LiveBackground result={result} className="d-flex justify-content-center overflow-hidden mt-2 live2-leap">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(backgroundType ? "/live-full" : "/")}
        >
            Back
        </button>
        <div>
            <div className="live-draw-heading d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    Leap
                </span> {getDateTime(result?.drawAt)}</div>

            <LayoutWrapper>
                <ContentWrapper>
                    <div className="d-flex position-relative" style={{
                        width: "100%",
                        height: "766px",
                        backgroundImage: `url(${require(`../../../assets/images/live-v2/leap/bg.jpg`)})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 100%"
                    }}>
                        <div style={config.style.container}>
                            <table className="table-responsive h-100 p-0 m-0 overflow-hidden">
                                <tbody className="h-100">
                                {result.results.map((row, i) => {
                                    return <tr key={i} className="h-100">
                                        <td style={config.style[`row_${i}`]} align="middle"
                                            className="w-100 h-100 border-tran">
                                            <RenderRow row={row} i={i}/>
                                        </td>
                                    </tr>
                                })}
                                </tbody>
                            </table>
                        </div>
                        <div style={{
                            // top: "0px", right: "55px",
                            width: "50%",
                            height: "766px",
                            backgroundImage: `url(${require(`../../../assets/images/live-v2/leap/post.png`)})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%"
                        }} className="d-flex justify-content-center align-items-center">
                            <div style={{height: "736px", marginLeft: "317px"}}>
                                {_.map(config.postToIndex, (value, key) => {
                                    const postsAll = [...result.results[0], ...result.results[2]];
                                    const item = postsAll[value]
                                    return <RenderResultItem key={key} item={item}/>
                                })}
                            </div>
                        </div>

                    </div>
                </ContentWrapper>

            </LayoutWrapper>


        </div>
    </LiveBackground>
}

export default Live2Leap;
